import React, { useEffect, createElement } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { PackagesSection } from './components/PackagesSection';
import { TrustSection } from './components/TrustSection';
import { FeaturesSection } from './components/FeaturesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { SoftPlayPackages } from './pages/SoftPlayPackages';
import { LuxurySoftPlayPackages } from './pages/LuxurySoftPlayPackages';
import { BounceHousePackages } from './pages/BounceHousePackages';
import { PhotoBoothPage } from './pages/PhotoBoothPage';
import { ContactPage } from './pages/ContactPage';
import { AboutPage } from './pages/AboutPage';
import { TestimonialsPage } from './pages/TestimonialsPage';
import { FAQPage } from './pages/FAQPage';
import { GalleryPage } from './pages/GalleryPage';
import { KidsBenefitsSection } from './components/KidsBenefitsSection';
import { CartPage } from './pages/CartPage';
import { BookingRequestPage } from './pages/BookingRequestPage';
import { BookingSuccessPage } from './pages/BookingSuccessPage';
// ScrollToTop component to handle automatic scrolling
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    // If there's a hash in the URL (like #faq), don't scroll to top
    if (hash) return;
    // Otherwise, scroll to top
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
export function App() {
  // Set the document title once when the app loads
  useEffect(() => {
    document.title = 'Toddler Time ATL - Premium Soft Play Rentals in Atlanta';
    // Global error handler for cross-origin script errors
    window.addEventListener('error', event => {
      // Suppress "Script error" from third-party scripts
      if (event.message === 'Script error.') {
        event.preventDefault();
        console.warn('Suppressed cross-origin script error');
        return false;
      }
    });
    // Load Google Tag Manager script with error handling
    try {
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17854662085';
      script1.onerror = () => {
        console.warn('Google Tag Manager failed to load');
      };
      document.head.appendChild(script1);
      // Initialize gtag
      const script2 = document.createElement('script');
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-17854662085');
      `;
      document.head.appendChild(script2);
    } catch (error) {
      console.warn('Error loading analytics:', error);
    }
  }, []);
  return <CartProvider data-id="element-0">
      <Router data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <div className="font-sans text-gray-800" data-id="element-3">
          <Header data-id="element-4" />
          <Routes data-id="element-5">
            <Route path="/softplay" element={<SoftPlayPackages data-id="element-7" />} data-id="element-6" />
            <Route path="/luxurysoftplay" element={<LuxurySoftPlayPackages data-id="element-9" />} data-id="element-8" />
            <Route path="/bouncehouse" element={<BounceHousePackages data-id="element-11" />} data-id="element-10" />
            <Route path="/photobooth" element={<PhotoBoothPage data-id="element-13" />} data-id="element-12" />
            <Route path="/contact" element={<ContactPage data-id="element-15" />} data-id="element-14" />
            <Route path="/about" element={<AboutPage data-id="element-17" />} data-id="element-16" />
            <Route path="/testimonials" element={<TestimonialsPage data-id="element-19" />} data-id="element-18" />
            <Route path="/faq" element={<FAQPage data-id="element-21" />} data-id="element-20" />
            <Route path="/gallery" element={<GalleryPage data-id="element-23" />} data-id="element-22" />
            <Route path="/cart" element={<CartPage data-id="element-25" />} data-id="element-24" />
            <Route path="/booking-request" element={<BookingRequestPage data-id="element-27" />} data-id="element-26" />
            <Route path="/booking-success" element={<BookingSuccessPage data-id="element-29" />} data-id="element-28" />
            <Route path="/" element={<main data-id="element-31">
                  <HeroSection data-id="element-32" />
                  <HowItWorksSection data-id="element-33" />
                  <TrustSection data-id="element-34" />
                  <PackagesSection data-id="element-35" />
                  <TestimonialsSection data-id="element-36" />
                  <KidsBenefitsSection data-id="element-37" />
                  <FeaturesSection data-id="element-38" />
                  <ContactSection data-id="element-39" />
                </main>} data-id="element-30" />
          </Routes>
          <Footer data-id="element-40" />
        </div>
      </Router>
    </CartProvider>;
}